/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AirlineDetail } from '../models/airlineDetail';

import type { AirlineList } from '../models/airlineList';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { HsCodeDetail } from '../models/hsCodeDetail';

import type { HsCodeList } from '../models/hsCodeList';

import type { HsCodeNomenclatureList } from '../models/hsCodeNomenclatureList';

import type { ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams } from '../models/listAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams';

import type { ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams } from '../models/listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams';

import type { ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams } from '../models/listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams';

import type { ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams } from '../models/listHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams';

import type { ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams } from '../models/listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams';

import type { ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams } from '../models/listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams';

import type { ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams } from '../models/listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams';

import type { ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams } from '../models/listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams';

import type { LoadUnitTypeDetail } from '../models/loadUnitTypeDetail';

import type { LoadUnitTypeList } from '../models/loadUnitTypeList';

import type { LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams } from '../models/lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams';

import type { MilestoneTypeOptionList } from '../models/milestoneTypeOptionList';

import type { OceanCarrierDetail } from '../models/oceanCarrierDetail';

import type { OceanCarrierList } from '../models/oceanCarrierList';

import type { PortLocationDetail } from '../models/portLocationDetail';

import type { PortLocationFilterFacets } from '../models/portLocationFilterFacets';

import type { PortLocationList } from '../models/portLocationList';

import type { ShipmentChecklistTemplateList } from '../models/shipmentChecklistTemplateList';

import type { TariffLookupResponse } from '../models/tariffLookupResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List load unit types, optionally filtered by category and/or country.

Shape B: omitting ``limit`` returns the complete equipment catalogue.
 * @summary List Load Unit Types
 */
export const listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet = (
  params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LoadUnitTypeList>({
    url: `/api/v1/shipments/reference-data/load-unit-types`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryKey =
  (
    params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/load-unit-types`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
        >
      >
    > = ({ signal }) =>
      listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
      >
    >
  >;
export type ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryError =
  HTTPValidationError;

export function useListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Load Unit Types
 */

export function useListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLoadUnitTypesApiV1ShipmentsReferenceDataLoadUnitTypesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single load unit type by ID.
 * @summary Get Load Unit Type
 */
export const getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet =
  (loadUnitTypeId: string, signal?: AbortSignal) => {
    return customInstance<LoadUnitTypeDetail>({
      url: `/api/v1/shipments/reference-data/load-unit-types/${loadUnitTypeId}`,
      method: 'GET',
      signal
    });
  };

export const getGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryKey =
  (loadUnitTypeId?: string) => {
    return [
      `/api/v1/shipments/reference-data/load-unit-types/${loadUnitTypeId}`
    ] as const;
  };

export const getGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    loadUnitTypeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryKey(
        loadUnitTypeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
        >
      >
    > = ({ signal }) =>
      getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet(
        loadUnitTypeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!loadUnitTypeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
      >
    >
  >;
export type GetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryError =
  HTTPValidationError;

export function useGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  loadUnitTypeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  loadUnitTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  loadUnitTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Load Unit Type
 */

export function useGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  loadUnitTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLoadUnitTypeApiV1ShipmentsReferenceDataLoadUnitTypesLoadUnitTypeIdGetQueryOptions(
      loadUnitTypeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search or list ports and airports.

When q is provided, searches by name, UN/LOCODE, IATA code, ICAO code, or city.
When only country_code is provided, lists all locations in that country.
Without filters, returns a paginated list of all locations.
 * @summary List Ports Locations
 */
export const listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet = (
  params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PortLocationList>({
    url: `/api/v1/shipments/reference-data/ports-locations`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryKey =
  (
    params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/ports-locations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
        >
      >
    > = ({ signal }) =>
      listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
      >
    >
  >;
export type ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryError =
  HTTPValidationError;

export function useListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Ports Locations
 */

export function useListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPortsLocationsApiV1ShipmentsReferenceDataPortsLocationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Countries in use on the active ports/locations base scope.
 * @summary Get Port Location Filter Facets
 */
export const getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet =
  (signal?: AbortSignal) => {
    return customInstance<PortLocationFilterFacets>({
      url: `/api/v1/shipments/reference-data/ports-locations/filter-facets`,
      method: 'GET',
      signal
    });
  };

export const getGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryKey =
  () => {
    return [
      `/api/v1/shipments/reference-data/ports-locations/filter-facets`
    ] as const;
  };

export const getGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
      >
    >
  >;
export type GetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryError =
  unknown;

export function useGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Port Location Filter Facets
 */

export function useGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPortLocationFilterFacetsApiV1ShipmentsReferenceDataPortsLocationsFilterFacetsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single port or airport by ID.
 * @summary Get Port Location
 */
export const getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet =
  (locationId: string, signal?: AbortSignal) => {
    return customInstance<PortLocationDetail>({
      url: `/api/v1/shipments/reference-data/ports-locations/${locationId}`,
      method: 'GET',
      signal
    });
  };

export const getGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryKey =
  (locationId?: string) => {
    return [
      `/api/v1/shipments/reference-data/ports-locations/${locationId}`
    ] as const;
  };

export const getGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    locationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryKey(
        locationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
        >
      >
    > = ({ signal }) =>
      getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet(
        locationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!locationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
      >
    >
  >;
export type GetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryError =
  HTTPValidationError;

export function useGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  locationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Port Location
 */

export function useGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPortLocationApiV1ShipmentsReferenceDataPortsLocationsLocationIdGetQueryOptions(
      locationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search or list airlines.

When q is provided, searches by name, IATA code, or ICAO code.
Without q, returns all airlines with optional filters.

Shape B: omitting ``limit`` returns the complete catalogue, on BOTH
branches — the resolved limit governs the search too.
 * @summary List Airlines
 */
export const listAirlinesApiV1ShipmentsReferenceDataAirlinesGet = (
  params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<AirlineList>({
    url: `/api/v1/shipments/reference-data/airlines`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryKey = (
  params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams
) => {
  return [
    `/api/v1/shipments/reference-data/airlines`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
      >
    > = ({ signal }) =>
      listAirlinesApiV1ShipmentsReferenceDataAirlinesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
    >
  >;
export type ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryError =
  HTTPValidationError;

export function useListAirlinesApiV1ShipmentsReferenceDataAirlinesGet<
  TData = Awaited<
    ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAirlinesApiV1ShipmentsReferenceDataAirlinesGet<
  TData = Awaited<
    ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAirlinesApiV1ShipmentsReferenceDataAirlinesGet<
  TData = Awaited<
    ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Airlines
 */

export function useListAirlinesApiV1ShipmentsReferenceDataAirlinesGet<
  TData = Awaited<
    ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAirlinesApiV1ShipmentsReferenceDataAirlinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAirlinesApiV1ShipmentsReferenceDataAirlinesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAirlinesApiV1ShipmentsReferenceDataAirlinesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single airline by ID.
 * @summary Get Airline
 */
export const getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet = (
  airlineId: string,
  signal?: AbortSignal
) => {
  return customInstance<AirlineDetail>({
    url: `/api/v1/shipments/reference-data/airlines/${airlineId}`,
    method: 'GET',
    signal
  });
};

export const getGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryKey =
  (airlineId?: string) => {
    return [`/api/v1/shipments/reference-data/airlines/${airlineId}`] as const;
  };

export const getGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    airlineId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryKey(
        airlineId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
        >
      >
    > = ({ signal }) =>
      getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet(
        airlineId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!airlineId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
      >
    >
  >;
export type GetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryError =
  HTTPValidationError;

export function useGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet<
  TData = Awaited<
    ReturnType<typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet>
  >,
  TError = HTTPValidationError
>(
  airlineId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet<
  TData = Awaited<
    ReturnType<typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet>
  >,
  TError = HTTPValidationError
>(
  airlineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet<
  TData = Awaited<
    ReturnType<typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet>
  >,
  TError = HTTPValidationError
>(
  airlineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Airline
 */

export function useGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet<
  TData = Awaited<
    ReturnType<typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet>
  >,
  TError = HTTPValidationError
>(
  airlineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAirlineApiV1ShipmentsReferenceDataAirlinesAirlineIdGetQueryOptions(
      airlineId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search or list ocean carriers (container shipping lines).

When q is provided, searches by name, short name, or SCAC code.
Without q, returns all carriers with optional filters.

Shape B: omitting ``limit`` returns the complete catalogue, on BOTH
branches — the resolved limit governs the search too.
 * @summary List Ocean Carriers
 */
export const listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet = (
  params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
  signal?: AbortSignal
) => {
  return customInstance<OceanCarrierList>({
    url: `/api/v1/shipments/reference-data/ocean-carriers`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryKey =
  (
    params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/ocean-carriers`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
        >
      >
    > = ({ signal }) =>
      listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
      >
    >
  >;
export type ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryError =
  HTTPValidationError;

export function useListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet<
  TData = Awaited<
    ReturnType<
      typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet<
  TData = Awaited<
    ReturnType<
      typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet<
  TData = Awaited<
    ReturnType<
      typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Ocean Carriers
 */

export function useListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet<
  TData = Awaited<
    ReturnType<
      typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOceanCarriersApiV1ShipmentsReferenceDataOceanCarriersGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single ocean carrier by ID.
 * @summary Get Ocean Carrier
 */
export const getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet =
  (carrierId: string, signal?: AbortSignal) => {
    return customInstance<OceanCarrierDetail>({
      url: `/api/v1/shipments/reference-data/ocean-carriers/${carrierId}`,
      method: 'GET',
      signal
    });
  };

export const getGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryKey =
  (carrierId?: string) => {
    return [
      `/api/v1/shipments/reference-data/ocean-carriers/${carrierId}`
    ] as const;
  };

export const getGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    carrierId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryKey(
        carrierId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
        >
      >
    > = ({ signal }) =>
      getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet(
        carrierId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!carrierId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
      >
    >
  >;
export type GetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryError =
  HTTPValidationError;

export function useGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
    >
  >,
  TError = HTTPValidationError
>(
  carrierId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
    >
  >,
  TError = HTTPValidationError
>(
  carrierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
    >
  >,
  TError = HTTPValidationError
>(
  carrierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ocean Carrier
 */

export function useGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
    >
  >,
  TError = HTTPValidationError
>(
  carrierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOceanCarrierApiV1ShipmentsReferenceDataOceanCarriersCarrierIdGetQueryOptions(
      carrierId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search, filter, or hierarchically browse HS codes.

- ``q`` searches by code prefix or description.
- ``parent_code`` lists the direct children of a code (drill down the tree).
- ``top_level`` returns the chapters (rows with no parent) — the browse root.
- Otherwise returns a paginated flat list, optionally filtered by
  ``level`` / ``chapter``. Filter by ``nomenclature`` (defaults to all).

Shape B (``HsCodesListPage`` slices client-side): this route used to carry a
``default=50, le=200`` cap, which § 11 forbids outright — a browse level or a
search wider than the cap silently lost rows. Omitting ``limit`` now returns
the complete result set, and every branch honours the resolved value.
 * @summary List Hs Codes
 */
export const listHsCodesApiV1ShipmentsReferenceDataHsCodesGet = (
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<HsCodeList>({
    url: `/api/v1/shipments/reference-data/hs-codes`,
    method: 'GET',
    params,
    signal
  });
};

export const getListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryKey = (
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams
) => {
  return [
    `/api/v1/shipments/reference-data/hs-codes`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>>
  > = ({ signal }) =>
    listHsCodesApiV1ShipmentsReferenceDataHsCodesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>>
  >;
export type ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryError =
  HTTPValidationError;

export function useListHsCodesApiV1ShipmentsReferenceDataHsCodesGet<
  TData = Awaited<
    ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHsCodesApiV1ShipmentsReferenceDataHsCodesGet<
  TData = Awaited<
    ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHsCodesApiV1ShipmentsReferenceDataHsCodesGet<
  TData = Awaited<
    ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Hs Codes
 */

export function useListHsCodesApiV1ShipmentsReferenceDataHsCodesGet<
  TData = Awaited<
    ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodesApiV1ShipmentsReferenceDataHsCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHsCodesApiV1ShipmentsReferenceDataHsCodesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHsCodesApiV1ShipmentsReferenceDataHsCodesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List the nomenclatures that actually have HS codes loaded (e.g. ['INTL']).

Drives the UI filter so only populated schedules are offered — national
schedules (US/EU/…) appear automatically once their seed lands.

Shape B: omitting ``limit`` returns every populated schedule.
 * @summary List Hs Code Nomenclatures
 */
export const listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet =
  (
    params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<HsCodeNomenclatureList>({
      url: `/api/v1/shipments/reference-data/hs-codes/nomenclatures`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryKey =
  (
    params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/hs-codes/nomenclatures`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
        >
      >
    > = ({ signal }) =>
      listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
      >
    >
  >;
export type ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryError =
  HTTPValidationError;

export function useListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet<
  TData = Awaited<
    ReturnType<
      typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet<
  TData = Awaited<
    ReturnType<
      typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet<
  TData = Awaited<
    ReturnType<
      typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Hs Code Nomenclatures
 */

export function useListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet<
  TData = Awaited<
    ReturnType<
      typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHsCodeNomenclaturesApiV1ShipmentsReferenceDataHsCodesNomenclaturesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single HS code by ID.
 * @summary Get Hs Code
 */
export const getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet = (
  hsCodeId: string,
  signal?: AbortSignal
) => {
  return customInstance<HsCodeDetail>({
    url: `/api/v1/shipments/reference-data/hs-codes/${hsCodeId}`,
    method: 'GET',
    signal
  });
};

export const getGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryKey =
  (hsCodeId?: string) => {
    return [`/api/v1/shipments/reference-data/hs-codes/${hsCodeId}`] as const;
  };

export const getGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
    >,
    TError = HTTPValidationError
  >(
    hsCodeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryKey(
        hsCodeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
        >
      >
    > = ({ signal }) =>
      getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet(hsCodeId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!hsCodeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
    >
  >;
export type GetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryError =
  HTTPValidationError;

export function useGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet<
  TData = Awaited<
    ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
  >,
  TError = HTTPValidationError
>(
  hsCodeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet<
  TData = Awaited<
    ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
  >,
  TError = HTTPValidationError
>(
  hsCodeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet<
  TData = Awaited<
    ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
  >,
  TError = HTTPValidationError
>(
  hsCodeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Hs Code
 */

export function useGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet<
  TData = Awaited<
    ReturnType<typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet>
  >,
  TError = HTTPValidationError
>(
  hsCodeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHsCodeApiV1ShipmentsReferenceDataHsCodesHsCodeIdGetQueryOptions(
      hsCodeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resolve the best-match tariff rate for a (HS code, lane) and return both
the raw rate and ready-to-merge duty/tariff estimate-line payloads.

Returns ``rate: null`` and ``suggested_lines: []`` when no rate matches.
 * @summary Lookup Tariff Rate
 */
export const lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet = (
  params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TariffLookupResponse>({
    url: `/api/v1/shipments/reference-data/tariff-rates`,
    method: 'GET',
    params,
    signal
  });
};

export const getLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryKey =
  (
    params?: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/tariff-rates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
        >
      >
    > = ({ signal }) =>
      lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
      >
    >
  >;
export type LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryError =
  HTTPValidationError;

export function useLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet<
  TData = Awaited<
    ReturnType<typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet>
  >,
  TError = HTTPValidationError
>(
  params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet<
  TData = Awaited<
    ReturnType<typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet>
  >,
  TError = HTTPValidationError
>(
  params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet<
  TData = Awaited<
    ReturnType<typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet>
  >,
  TError = HTTPValidationError
>(
  params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Lookup Tariff Rate
 */

export function useLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet<
  TData = Awaited<
    ReturnType<typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet>
  >,
  TError = HTTPValidationError
>(
  params: LookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof lookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getLookupTariffRateApiV1ShipmentsReferenceDataTariffRatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List active checklist templates. When shape filters are supplied, the
response also flags which template would be suggested.

Shape B: omitting ``limit`` returns every active template.
 * @summary List Checklist Templates
 */
export const listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet =
  (
    params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentChecklistTemplateList>({
      url: `/api/v1/shipments/reference-data/checklist-templates`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryKey =
  (
    params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/checklist-templates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
        >
      >
    > = ({ signal }) =>
      listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
      >
    >
  >;
export type ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryError =
  HTTPValidationError;

export function useListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Checklist Templates
 */

export function useListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChecklistTemplatesApiV1ShipmentsReferenceDataChecklistTemplatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Active milestone types (code + description), ordered by typical sequence.

Powers the workflow-template milestone-plan editor — the operator picks
milestone codes for the ordered plan and sets a date offset per code — and
the manual Add-Milestone dialog's vocabulary picker. ``dnd_starts`` /
``dnd_stops`` flag which D&D charge clocks (demurrage / detention / …) a code
anchors, so a clerk can see which codes start or stop a clock before
recording one.
 * @summary List Milestone Types
 */
export const listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet = (
  params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<MilestoneTypeOptionList>({
    url: `/api/v1/shipments/reference-data/milestone-types`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryKey =
  (
    params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams
  ) => {
    return [
      `/api/v1/shipments/reference-data/milestone-types`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
        >
      >
    > = ({ signal }) =>
      listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
      >
    >
  >;
export type ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryError =
  HTTPValidationError;

export function useListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Milestone Types
 */

export function useListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMilestoneTypesApiV1ShipmentsReferenceDataMilestoneTypesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
